/* eslint-disable max-len */
export default {
    title: 'Kontakt',
    form: {
        title: 'Zostaw wiadomość, z chęcią odpowiemy.',
        placeholder: {
            name: 'Imię',
            surname: 'Nazwisko',
            email: 'Twój firmowy email',
            phone: 'Numer telefonu',
            message: 'Wiadomość',
            topic: 'Wybierz temat'
        },
        label: {
            checkbox: 'Dane administrowane są przez Sagiton Sp. z o.o., zostały przekazane dobrowolnie i będą przetwarzane przez administratora zgodnie z przepisami ustawy z dnia 29 sierpnia 1997r. o ochronie danych osobowych (Dz. U. z 2002r. nr 101, poz. 926 z późn. zm.) w celach marketingowych, sprzedaży produktów i usług Sagiton Sp.z o.o. Zostałem/am poinformowany/a o prawie dostępu do treści swoich danych, ich poprawiania oraz prawie wniesienia w każdym czasie sprzeciwu wobec ich przetwarzania.',
            checkbox2: 'Wyrażam zgodę na otrzymywanie od Sagiton Sp.z o.o. informacji handlowej za pomocą poczty elektronicznej.',
            button: 'Wyślij',
            refresh: 'Odśwież',
            showEmail: 'Odkryj Email',
            mailToTitle: 'zapytanie',
            mailToDisclaimerText: 'Aby mieć pewność, że Twoje zgłoszenie nie zostanie uznane za ruch typu SPAM/BOT, użyj poniższego adresu e-mail, który zawiera unikalny token przydzielony Tobie'
        }
    },
    people: {
        title: 'Nie czekaj i wyślij e-mail teraz',
        button: 'Rozmowa z konsultantem',
        labels: {
            mobile: 'mobile',
            mail: 'mail'
        },
        list: [{
            name: 'Grzegorz Mąkosa',
            occupation: 'Business Development Partner',
            phone: '+48 71 700 03 01',
            email: 'grzegorz.makosa@lemlock.com'
        }]
    },
    headquarter: {
        title: 'Adres',
        address: {
            company: 'Lemlock',
            note: 'Marka lemlock jest własnością Sagiton sp. z o.o.',
            country: ''
        }
    },
    map: {
        placeId: 'ChIJj0OamfvBD0cR2pqv0Y9-3UQ',
        infowindow: {
            navigate_text: 'Wskazówki dojazdu',
            navigate_url: 'https://www.google.com/maps?ll=51.1124,16.985984&z=16&t=m&hl=pl&gl=PL&mapclient=embed&daddr=Lemlock+-+Testy+Penetracyjne+Fabryczna+19+53-609+Wroc%C5%82aw@51.1124002,16.9859843',
            review_text: 'Zobacz opinie',
            review_url: 'http://www.google.pl/search?q=Lemlock+-+Testy+Penetracyjne,+Fabryczna+19,+53-609+Wroc%C5%82aw&ludocid=4962261520595524314#lrd=0x470fc1fb999a438f:0x44dd7e8fd1af9ada,1',
            large_map_text: 'Wyświetl większą mape'
        }
    }
};



// WEBPACK FOOTER //
// ./src/i18n/pl/contact.js